import { render, staticRenderFns } from "./SourcesCouverturePage.vue?vue&type=template&id=98411b22&scoped=true"
import script from "./SourcesCouverturePage.vue?vue&type=script&lang=js"
export * from "./SourcesCouverturePage.vue?vue&type=script&lang=js"
import style0 from "./SourcesCouverturePage.vue?vue&type=style&index=0&id=98411b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98411b22",
  null
  
)

export default component.exports